import React from 'react';
import { ToolTip } from 'design-system';
const ProRataTooltip = () => (<ToolTip small title="What does pro-rata mean?" subtitle="We calculate charges and refunds based on exactly how long you’ve used your plan. When you upgrade, we automatically credit the unused time, so you only pay for what you use."/>);
export default ProRataTooltip;
